import scrollParent from './scroll-parent.js';

if (/Android [4-6]/.test(navigator.appVersion)) {
	window.addEventListener('resize', () => {
		if (document.activeElement.tagName === 'INPUT') {
			window.setTimeout(() => {
				const el = document.activeElement;
				const rect = el.getBoundingClientRect();

				const container = scrollParent(el);
				const containerHeight = container.clientHeight;

				// scroll to center of visible area
				//console.log(`${rect.top}, ${rect.height}, ${containerHeight}`);
				container.scrollTop = (rect.top + container.scrollTop + (rect.height / 2)) - (containerHeight / 2);

			}, 0);
		}
	});
}



// WEBPACK FOOTER //
// ./mobile-core/src/utils/android-focus.js